
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface SidebarToggleProps {
  isExpanded: boolean;
  onClick: () => void;
  forceDisabled?: boolean;
}

export const SidebarToggle = ({ 
  isExpanded, 
  onClick,
  forceDisabled = false
}: SidebarToggleProps) => {
  return (
    <Button
      variant="secondary"
      size="sm"
      className={cn(
        "absolute left-full -translate-x-8 top-24 rotate-90 bg-white border shadow-sm z-[11]",
        forceDisabled && "opacity-50"
      )}
      onClick={onClick}
      disabled={forceDisabled}
    >
      <ChevronRight className={cn(
        "h-4 w-4 transition-transform duration-200",
        isExpanded && "rotate-180"
      )} />
      <span className="ml-2">{isExpanded ? "Close" : "Pixels"}</span>
    </Button>
  );
};
